import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import CreateWorkspace from '@/components/createWorkspace/CreateWorkspace'
import { Button } from '@deepguide-ai/ui'

// Manual workspace creation is dev-only. PROD orgs are 1:1 with workspaces
// (auto-provisioned), so this surface is never exposed there.
const ALLOW_MANUAL_WORKSPACE_CREATION = import.meta.env.DEV

export const Route = createFileRoute('/(protected)/workspaces/new')({
  component: WorkspaceNew,
  beforeLoad: () => {
    if (!ALLOW_MANUAL_WORKSPACE_CREATION) {
      throw redirect({ to: '/', replace: true })
    }
    return {
      skipParentLayout: true,
    }
  },
})

export function WorkspaceNew() {
  const navigate = useNavigate()

  const goBack = () => {
    navigate({ to: '/' })
  }

  return (
    <div className='bg-background max-w relative flex h-dvh w-dvw flex-col items-center justify-center'>
      <Button
        variant='ghost'
        size='icon'
        className='absolute top-4 left-4'
        onClick={goBack}
      >
        <ArrowLeft size={16} />
      </Button>
      <CreateWorkspace />
    </div>
  )
}
